import { nakiRadioSystemTypes } from "common/constants";
import BaseHomeSectionListViewStore from "./BaseHomeSectionListViewStore";

class NakiMobileEmbeddedHomeSectionListViewStore extends BaseHomeSectionListViewStore {
    constructor(rootStore, { routeStore }) {
        super(rootStore, { routeStore });
        this.mobileAppSystemType = nakiRadioSystemTypes.mobile_embedded;
    }
}

export default NakiMobileEmbeddedHomeSectionListViewStore;
